import Field from "@/components/Field";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

interface QuestionnaireCheckboxFieldProps {
  name: string;
  label: string;
  required?: boolean;
  isImportant?: boolean;
  disabled?: boolean;
}

export function QuestionnaireCheckboxField({
  name,
  label,
  required = false,
  isImportant = false,
  disabled = false,
}: QuestionnaireCheckboxFieldProps) {
  return (
    <Field
      name={name}
      required={required}
      render={({ field }) => (
        <div
          className={cn(
            "flex items-start gap-3 cursor-pointer transition-colors",
            isImportant
              ? "rounded-md border border-blue-200 bg-blue-50 px-3 py-3 hover:bg-blue-100"
              : "px-1 py-1",
            disabled && "opacity-50 cursor-not-allowed",
          )}
        >
          <Checkbox
            id={name}
            checked={field.value}
            onCheckedChange={field.onChange}
            disabled={disabled}
            className={cn("shrink-0", { "mt-1": isImportant })}
          />
          <label
            htmlFor={name}
            className={cn(
              "flex-1 cursor-pointer text-sm font-medium leading-tight text-slate-900",
              isImportant && "text-base font-semibold",
            )}
          >
            {label}
          </label>
        </div>
      )}
    />
  );
}
